export const IndoorPlants: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_1006_1199"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M0 7.62939e-06H80V80H0V7.62939e-06Z" fill="white" />
      </mask>
      <g mask="url(#mask0_1006_1199)">
        <path
          d="M70 35.7813V75.3125H10V35.7813"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M64.082 20.4881L78.4375 29.9067L73.3172 37.7109L40 15.8516L6.68281 37.7109L1.5625 29.9067L40 4.68782L52.332 12.7789"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M10 24.1992V9.0625H20V17.4394"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <mask
        id="mask1_1006_1199"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M0 7.62939e-06H80V80H0V7.62939e-06Z" fill="white" />
      </mask>
      <g mask="url(#mask1_1006_1199)">
        <path
          d="M45.8085 75.3125H34.1918L31.4585 61.5625H48.5418L45.8085 75.3125Z"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M50 44.6875H46.712C43.0052 44.6875 40 47.6927 40 51.3995V54.6875H43.288C46.9948 54.6875 50 51.6823 50 47.9755V44.6875Z"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30 44.6875H33.288C36.9948 44.6875 40 47.6927 40 51.3995V54.6875H36.712C33.0052 54.6875 30 51.6823 30 47.9755V44.6875Z"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M40 53.0383V61.5625"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
